// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"259e62cf","782":"4d005fa3","959":"c611ab59"}[chunkId] + ".chunk.css";
};